import i18next from 'i18next'

import localeEnglish from '@/javascript/locales/en.json'
import localeSpanish from '@/javascript/locales/es.json'

/*
	TODO: This would work better as a Vue plugin, which will allow initializing to happen after `
	window.current_user` is set. Right now, we have to call `initTranslations` within modals and
	on each pack file for the caregiver dashboard to help with the race condition within the unit tests.
*/
export function initTranslations() {
	i18next.init({
		compatibilityJSON: 'v3',
		debug: false,
		fallbackLng: 'en',
		lng: window.current_user ? window.current_user.language : 'en',
		resources: {
			en: { translation: localeEnglish.en },
			es: { translation: localeSpanish.es },
		},
		returnNull: false,
	}, (error: Error | null) => {
		if (!error) {
			const currentLang = i18next.language || 'en'

			document.documentElement.setAttribute('lang', currentLang)
		}
	})
}

export default i18next.t
